var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container-app"
  }, [_c('b-card', {
    staticClass: "card-header"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "pdv-pesquisa",
    attrs: {
      "md": "6"
    }
  }, [_vm._t("formulario")], 2), _c('b-col', {
    staticClass: "pdv-valor"
  }, [_vm._t("quantidade")], 2), _c('b-col', {
    staticClass: "pdv-valor"
  }, [_vm._t("valor")], 2), _c('b-col', {
    staticClass: "pdv-button"
  }, [_vm._t("addButton")], 2)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };